export default __webpack_public_path__ + "static/media/formsAutoData.14f80a76.png";